import { LaneAlert } from 'apps/marketplace/apiTypes/carrierLaneAlerts'

export type TSavedLaneValueParser = (laneAlert: LaneAlert) => React.ReactNode
export const getColumns = (flagEnabled: Boolean) => {
  return {
    lanePreference: 'Lane Preference',
    minTotalRate: 'Min Rate',
    pickupAvailability: 'Pickup Availability',
    recipient: 'Recipients',
    ...(!flagEnabled ? { addedBy: 'Added By' } : {}),
  }
}
